import en from 'yup/lib/locale'

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function setYupLocale(yup: any, lang: string): void {
  if (lang === 'is') {
    /* eslint-disable no-template-curly-in-string */
    yup.setLocale({
      mixed: {
        default: '${path} er ógildur',
        required: '${path} er skyldureitur',
      },
      string: {
        max: '${path} má vera hámark ${max} stafir að lengd',
        url: '${path} verður að vera gild vefslóð',
        length: '${path} verður að vera nákvæmlega ${length} stafir að lengd',
        min: '${path} verður að vera að minnsta kosti ${min} stafir að lengd',
        // matches: '${path} must match the following: "${regex}"',
        email: '${path} verður a vera gilt netfang',
        // uuid: '${path} must be a valid UUID',
        // trim: '${path} must be a trimmed string',
        // lowercase: '${path} must be a lowercase string',
        // uppercase: '${path} must be a upper case string',
      },
    })
    /* eslint-enable */
  } else {
    yup.setLocale(en)
  }
}

export const ADULT_AGE = 18
export const KENNITALA_LENGTH = 10
const CENTURY_BY_DIGIT: Record<number, number> = { 0: 2000, 8: 1800, 9: 1900 }

export function normalizeSsn(ssn: string | undefined | null): string {
  return (ssn ?? '').replace(/-/g, '')
}

export function isAdultAge(age: number | undefined | null): boolean {
  return age != null && age >= ADULT_AGE
}

export function ageFromKennitala(ssn: string): number | null {
  const digits = normalizeSsn(ssn)
  if (digits.length !== KENNITALA_LENGTH) return null
  const day = parseInt(digits.substring(0, 2), 10)
  const month = parseInt(digits.substring(2, 4), 10)
  const yearShort = parseInt(digits.substring(4, 6), 10)
  const century = CENTURY_BY_DIGIT[parseInt(digits.substring(9, 10), 10)]
  if (century === undefined) return null
  const birth = new Date(century + yearShort, month - 1, day)
  if (isNaN(birth.getTime())) return null
  const now = new Date()
  let age = now.getFullYear() - birth.getFullYear()
  const monthDiff = now.getMonth() - birth.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) age--
  return age
}
